<div class="table-container">
    <table mat-table [dataSource]="dataSource" class="mat-elevation-z8">
  
      <!-- Platform Column -->
      <ng-container matColumnDef="platform">
        <th mat-header-cell *matHeaderCellDef> Platform </th>
        <td mat-cell *matCellDef="let element"> {{ element.platform }} </td>
      </ng-container>
  
      <!-- Platform ID Column -->
      <ng-container matColumnDef="platformId">
        <th mat-header-cell *matHeaderCellDef> Platform ID </th>
        <td mat-cell *matCellDef="let element"> {{ element.platformId }} </td>
      </ng-container>
  
      <!-- Country Column -->
      <ng-container matColumnDef="country">
        <th mat-header-cell *matHeaderCellDef> Country </th>
        <td mat-cell *matCellDef="let element"> {{ element.country }} </td>
      </ng-container>
  
      <!-- Location Name Column -->
      <ng-container matColumnDef="locationName">
        <th mat-header-cell *matHeaderCellDef> Location Name </th>
        <td mat-cell *matCellDef="let element"> {{ element.locationName }} </td>
      </ng-container>
  
      <!-- Location ID Column -->
      <ng-container matColumnDef="locationId">
        <th mat-header-cell *matHeaderCellDef> Location ID </th>
        <td mat-cell *matCellDef="let element"> {{ element.locationId }} </td>
      </ng-container>
  
      <!-- Pincode Column -->
      <ng-container matColumnDef="pincode">
        <th mat-header-cell *matHeaderCellDef> Pincode </th>
        <td mat-cell *matCellDef="let element"> {{ element.pincode }} </td>
      </ng-container>
  
      <tr mat-header-row class="bg-primary text-light" *matHeaderRowDef="displayedColumns; sticky: true"></tr>
      <tr mat-row class="" style="font-size: small;" *matRowDef="let row; columns: displayedColumns"></tr>
    </table>
  </div>
  
